// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/InstagramAccounts_BuscaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /instagram/accounts/busca/<id>
 *
 * Returns a single Instagram account from the upstream
 * instagram-messaging-service, enriched with the local franchise_ids it is
 * linked to (no franquias_nomes — the busca endpoint is used by the edit
 * form which renders the chip names from the franquia_ids itself).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface InstagramAccounts_BuscaResponseDados {
instagram_account_id: number
ig_user_id: string
ig_username: string
active: boolean
franquia_ids: number[]
page_id?: string
page_name?: string
token_expires_at?: string
}

export type InstagramAccounts_BuscaResponse = ApiResponse<InstagramAccounts_BuscaResponseDados>;

registerResponseContract('InstagramAccounts_BuscaResponse', {
  instagram_account_id: { type: 'number',  required: true },
  ig_user_id:           { type: 'string',  required: true },
  ig_username:          { type: 'string',  required: true },
  active:               { type: 'boolean', required: true },
  franquia_ids:         { type: 'array',   required: true },
  page_id:              { type: 'string',  required: false },
  page_name:            { type: 'string',  required: false },
  token_expires_at:     { type: 'string',  required: false },
})
